import React, {Component} from 'react';
import PageTitle from '../../components/PageTitle';
import {connect} from 'react-redux';
import ClientActions from '../../redux/ClientRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import NoteForm from './components/NoteForm';

import ClientPassportForm from './components/ClientPassportForm';
import ClientInfoForm from './components/ClientInfoForm';
import Blanket from '@atlaskit/blanket';
import isEqual from 'react-fast-compare';
import CarsPage from './CarsPage';
import { EditViewContext } from './components/EditViewContext';
import {scrollTo} from '../../helpers/navigate';
import ContentWrapper from '../../components/ContentWrapper';
import Forbidden from '../../components/Forbidden';
import {withTranslation} from 'react-i18next';

class ClientPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: null,
      client: {
        id: null,
        fullName: '',
        dateOfBirth: null,
        dateOfLicense: null,
        gender: {},
        passport: {},
        livingAddress: '',
        email: '',
        phone: '',
        note: '',
      },
    };
  }

  componentDidMount() {
    const {get} = this.props;
    const requestedId = this.props.match.params.id;
    get(requestedId);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching) {
        if (!this.props.error) {
          if (prevProps.client
            && !this.props.client) {
              //пользователь был удален
              this.props.history.goBack();
          } else if (this.props.match.params.id === 'new'
            && this.props.client) {
              //пользователь был добавлен
              this.props.history.goBack();
          } else if (this.props.client) {
            //даные пользователя загружены
            let data = {};
            Object.keys(this.state.client).map(key => data[key] = this.props.client[key])
            this.setState({
              client: data,
              edit: null,
            });
          } else {
            //произошла ошибка - дилер не найден, другие ошибки выводим глобально
            this.props.history.goBack();
          }
        
        } else if (!this.state.client.fullName) {
          //произошла ошибка - дилер не найден, другие ошибки выводим глобально
          this.props.history.goBack();
        }
    }
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {update} = this.props;
    const {client} = this.state;
    let dataForUpdate = {};
    Object.keys(client).map(key => {
      if (!isEqual(client[key], this.props.client[key])) {
        dataForUpdate[key] = client[key];
      }
    })

    if (Object.keys(dataForUpdate).length === 0) {
      //waranty: Должен быть вывод ошибки, так как из required для select не работает.

    } else {
      update({
        ...dataForUpdate,
        id: this.props.client.id
      });
    }
  }

  onCancel = () => {
    let data = {};
    Object.keys(this.state.client).map(key => data[key] = this.props.client[key])
    this.setState({
      client: data,
      edit: null,
    });
  }

  onChange = (name, value) => {
    if (name.includes('.')) {
      const path = name.split('.');
      if (path.length === 2) {
        let obj = {...this.state.client[path[0]]};
        obj[path[1]] = value;
        this.setState({
          client: {...this.state.client, [path[0]]: obj},
        });
      }
    } else {
      this.setState({
        client: {...this.state.client, [name]: value},
      });
    }
  }
  
  onEditMode = formName => () => {
    if (!this.state.edit) {
      scrollTo(formName ==='car' ? 'cars' : formName);
      //this.props.history.push(`#${formName ==='car' ? 'cars' : formName}`);
      this.setState({edit: formName})
    } else {
      this.setState({edit: null})
    }
  }

  render() {
    const {client, edit} = this.state;
    const {
      fetching,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;

    if (!client.id) {
      return null;
    }
    if (!permissions) {
      return <Forbidden />;
    }

    return (
      <EditViewContext.Provider 
        value={{
          edit: this.state.edit,
          permissions: permissions,
          onChangeEditMode: this.onEditMode,
          onChange: this.onChange,
        }}>
        <ContentWrapper>
          <PageTitle>{t('Client details')}</PageTitle>
          <form onSubmit={this.onFormSubmit}>
            <ClientInfoForm
              fetching={fetching}
              dictionaries={dictionaries}
              getDictionaries={getDictionaries}
              onCancel={this.onCancel}
              {...client}
            />
            <ClientPassportForm
              passport={client.passport}
              livingAddress={client.livingAddress}
              fetching={fetching}
              onCancel={this.onCancel}
            />
          </form>

          <CarsPage
            edit={edit}
            onShowFormBlank={this.onEditMode('car')}
            location={this.props.location}
          />

          <form onSubmit={this.onFormSubmit}>
            <NoteForm
              note={client.note}
              fetching={fetching}
              onCancel={this.onCancel}
            />
          </form>

          <Blanket
            onBlanketClicked={!this.props.allFetching && this.onCancel}
            isTinted={!!edit}
            canClickThrough={!edit}
          />
        </ContentWrapper>
      </EditViewContext.Provider>
    );
  }
}

const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.client,
    client: state.client.data,
    fetching: state.client.fetching,
    error: state.client.error,
    dictionaries: state.dictionaries,
    allFetching: state.client.fetching || state.cars.fetching
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get: id => dispatch(ClientActions.clientRequest(id)),
    update: data => dispatch(ClientActions.clientUpdateRequest(data)),
    delete: id => dispatch(ClientActions.clientDeleteRequest(id)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('clients', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClientPage));
